import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Column, Field, Control, Label, Input } from "rbx";
import { VehicleSelect, SystemCodeSelect } from "../inputs";

const VehicleOutOfServiceForm = ({ inputs, onChange, excludedStatuses }) => (
  <div style={{ marginTop: "2rem" }}>
    <Column.Group>
      <Column>
        <Field>
          <Column.Group>
            <Column size={6}>
              <VehicleSelect
                firstOptionEnabled
                orderByNumber
                required
                Vehicle={inputs.Vehicle}
                disabled={!!inputs.RecId}
                label="Vehicle Number"
                name="VehicleRecIdRef"
                value={inputs.VehicleRecIdRef}
                vehicleType={inputs.VehicleTypeRecIdRef}
                onChange={onChange}
              />
            </Column>
            <Column size={6}>
              <VehicleSelect
                firstOptionEnabled
                required
                Vehicle={inputs.Vehicle}
                disabled={!!inputs.RecId}
                label="Vehicle Description"
                name="VehicleRecIdRef"
                value={inputs.VehicleRecIdRef}
                variables={{ Active: true }}
                vehicleType={inputs.VehicleTypeRecIdRef}
                onChange={onChange}
              />
            </Column>
          </Column.Group>
          <Column.Group>
            <Column>
              <Control expanded>
                <SystemCodeSelect
                  required
                  label="Status"
                  name="StatusRecIdRef"
                  readOnly={inputs.RecId && inputs.RecId !== "isNew"}
                  value={inputs.StatusRecIdRef}
                  where={{
                    CodeName: "VehicleStatus",
                    RecId_not_in: excludedStatuses
                  }}
                  onChange={onChange}
                />
              </Control>
            </Column>
            <Column>
              <Control>
                <Label>Out Of Service Date</Label>
                <Input
                  required
                  disabled={inputs.RecId && inputs.RecId !== "isNew"}
                  name="OutOfServiceDate"
                  type="date"
                  value={
                    inputs.OutOfServiceDate
                      ? moment(inputs.OutOfServiceDate).format("YYYY-MM-DD")
                      : ""
                  }
                  onChange={onChange}
                />
              </Control>
            </Column>
          </Column.Group>
          <Column.Group>
            <Column>
              <Field>
                <Control>
                  <Label>Comment</Label>
                  <Input
                    required
                    autoComplete="off"
                    name="Comment"
                    type="text"
                    value={inputs.Comment}
                    onChange={onChange}
                  />
                </Control>
              </Field>
            </Column>
          </Column.Group>
        </Field>
      </Column>
    </Column.Group>
  </div>
);
VehicleOutOfServiceForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func,
  excludedStatuses: PropTypes.array
};

VehicleOutOfServiceForm.defaultProps = {
  inputs: {},
  excludedStatuses: []
};
export default VehicleOutOfServiceForm;
